import { render, staticRenderFns } from "./CandidateAdditionalComments.vue?vue&type=template&id=6f28367c&scoped=true"
import script from "./CandidateAdditionalComments.vue?vue&type=script&lang=js"
export * from "./CandidateAdditionalComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28367c",
  null
  
)

export default component.exports